const planPrices: { [key: string]: { monthly: number, monthlyYear: number, yearly: number, yearlyMonth: number } } = {
    1000: { monthly: 0, monthlyYear: 0, yearly: 0, yearlyMonth: 0 },
    1001: { monthly: 19.90, monthlyYear: 238.80, yearly: 154.80, yearlyMonth: 12.90 },
    1002: { monthly: 49.90, monthlyYear: 598.80, yearly: 358.80, yearlyMonth: 29.90 },
    1003: { monthly: 69.90, monthlyYear: 838.80, yearly: 598.80, yearlyMonth: 49.90 },
    1004: { monthly: 129.90, monthlyYear: 1558.80, yearly: 1198.80, yearlyMonth: 99.90 },
    1005: { monthly: 189.90, monthlyYear: 2278.80, yearly: 1798.80, yearlyMonth: 149.90 },
    1006: { monthly: 789.90, monthlyYear: 9478.80, yearly: 6358.80, yearlyMonth: 529.90 }
};

export default planPrices;
